var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 15,
    viewBox: "0 0 66 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2897 12.4301C30.0893 14.5519 33.9456 14.5992 36.7963 12.5466L61.8718 -5.50773C68.1753 -10.0462 64.9647 -20 57.1974 -20H8.30017C0.63245 -20 -2.64293 -10.2557 3.46801 -5.62424L27.2897 12.4301Z",
    fill: "#ED628B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.976e2918ab3ab411d857c3214158289b.svg";
export { ForwardRef as ReactComponent };